export default __webpack_public_path__ + "static/media/managepost.6cedbae2.svg";